import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e18bf7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid mb-0 py-3 py-lg-5 bg-gray" }
const _hoisted_2 = {
  key: 2,
  class: "container"
}
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "col-xl-5" }
const _hoisted_5 = { class: "fw-bold text-center mb-3 mb-lg-5" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" に招待されました。 ")
const _hoisted_9 = { class: "text-center fs-6 fw-bold mb-3 mb-lg-4 not-registered" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mx-auto mb-3 mb-lg-4" }, null, -1))
const _hoisted_11 = { class: "d-flex justify-content-center mb-3 mb-lg-4 p-0" }
const _hoisted_12 = { class: "text-center fs-6 fw-bold mb-3 mb-lg-4" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mx-auto mb-3 mb-lg-4" }, null, -1))
const _hoisted_14 = { class: "row justify-content-center" }
const _hoisted_15 = { class: "col-xl-5" }
const _hoisted_16 = { class: "bg-white rounded-4 shadow p-3 p-lg-5" }
const _hoisted_17 = ["onSubmit"]
const _hoisted_18 = { class: "row mb-0 mb-lg-4" }
const _hoisted_19 = { class: "w-max-content col-lg-4 col-form-label text-left" }
const _hoisted_20 = { class: "col-lg-8" }
const _hoisted_21 = { class: "row mb-4" }
const _hoisted_22 = { class: "w-max-content col-lg-4 col-form-label text-left" }
const _hoisted_23 = { class: "col-lg-8" }
const _hoisted_24 = {
  key: 0,
  class: "d-flex justify-content-center justify-content-lg-end"
}
const _hoisted_25 = {
  key: 1,
  class: "text-danger text-end mt-2"
}
const _hoisted_26 = { class: "d-flex justify-content-center mt-5 mb-2 mb-lg-3 align-items-center" }
const _hoisted_27 = { class: "text-center fs-7 w-100 mb-3 sns-integration-note" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import Button from '@/components/button/index.vue'
import CardFooter from '../components/CardFooter.vue'
import { ref, computed, onMounted, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { translate } from '@/languages/i18n'
import useVuelidate from '@vuelidate/core'
import { required, email, maxLength, minLength } from '@vuelidate/validators'
import { customMaxLength } from '@/utils'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import userService from '@/services/auth.service'
import ErrorMessage from '@/components/error-message'
import { getCookie, setHeaders } from '@/utils'
import { omit } from 'lodash'
import { PATH } from '@/constants'
import { PASSWORD_REGEX } from '@/constants/regex'
import { MIN_LENGTH_EMAIL, MAX_LENGTH_EMAIL } from '@/constants/number'
import { AUTH_STORE, COMMUNITY_STORE } from '@/store/constants'
import { useStore } from 'vuex'
import { removeCookie } from '@/utils'
import RecaptCha from '@/views/shared/components/RecaptCha.vue'
import SnsLoginButton from '@/components/sns-login-button/index.vue'
import { SNS_METHOD, snsConnectDefinedErrorMsg } from '@/constants/common'
import ErrorToast from '@/components/toast-error/indexErrorToast.vue'
import { useToast } from 'vue-toastification'
type InvitedCommunity = {
  corporation_name: string
  community_name: string
  invited_code: string
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isCheckRecaptcha = `${process.env.VUE_APP_CHECK_RECAPTCHA}`
const store = useStore()
const invitedCodeNotFound = ref<boolean>(false)
const invalidUrlError = ref<boolean>(false)
const errorLogin = ref<boolean>(false)
const checkCaptcha = ref(false)
const disableBtn = ref(false)
const reCaptChaRef = ref<InstanceType<typeof RecaptCha>>()

const toast = useToast()
const route = useRoute()
const router = useRouter()

const checkSubmit = ref(false)

const invitedCommunity = ref<InvitedCommunity>({
  corporation_name: '',
  community_name: '',
  invited_code: '',
})

const formData = ref({
  email: '',
  password: '',
  'g-recaptcha-response-data': '',
})

onMounted(() => {
  if (isCheckRecaptcha == 'false') {
    checkCaptcha.value = true
  }

  checkAndHandleConnectError()
})

const checkAndHandleConnectError = () => {
  const { errorCode } = route.query
  if (snsConnectDefinedErrorMsg.includes(errorCode?.toString().toUpperCase() ?? '')) {
    toast.error({
      component: ErrorToast,
      props: {
        messageCode: errorCode?.toString()?.toUpperCase(),
      },
    })

    router.replace({ ...router.currentRoute, query: omit(route.query, ['errorCode']) })
  }
}
watch(
  [() => formData.value.email, () => formData.value.password, () => checkCaptcha.value],
  () => {
    if (formData.value.email !== '' && formData.value.password !== '' && checkCaptcha.value) {
      disableBtn.value = false
    } else {
      disableBtn.value = true
    }
  },
  {
    immediate: true,
  }
)

const rules = computed(() => {
  return {
    email: {
      required,
      maxLength: (value: string) => customMaxLength(value, MAX_LENGTH_EMAIL),
      minLength: minLength(MIN_LENGTH_EMAIL),
      email,
    },
    password: {
      required,
      maxLength: maxLength(128),
      minLength: minLength(8),
      containsType: function (value) {
        return PASSWORD_REGEX.test(value)
      },
    },
    'g-recaptcha-response-data': isCheckRecaptcha == 'false' ? '' : { required },
  }
})
const v$ = useVuelidate(rules, formData)

const recaptchaVerified = (response: any): void => {
  checkCaptcha.value = true
  formData.value['g-recaptcha-response-data'] = response
}

const submit = async (): void => {
  checkSubmit.value = true

  v$.value.$touch()
  if (v$.value.$invalid) return

  if (checkCaptcha.value) {
    try {
      const data = await userService.alumnusLoginApi(formData.value)

      if (data.headers?.expiry) {
        const { expiry } = data.headers

        // 2022/10/26 CW-TrungNT Fix UAT#4665: SA10 (Ph2-R20221028)
        let expires = `${expiry ? new Date(parseInt(expiry) * 1000).toUTCString() : new Date()['toGMTString']()}`

        const basePath = PATH[`${route.path.split('/')[1]}`]
        const dataHeader = { ...data.headers, 'request-path': basePath.path }

        document.cookie = `${basePath.pathName}=${basePath.path}; expires=${expires}; path=/`
        document.cookie = `${basePath.header}=${JSON.stringify(omit(dataHeader, ['cache-control', 'content-type']))}; expires=${expires}; secure; path=/`
        document.cookie = `${basePath.path}-required-two-factor=true; expires=${expires}; secure; path=/`
        setHeaders(dataHeader)
        errorLogin.value = false

        redirectPage()
      } else if (data?.data?.one_time_password) {
        // 10 minutes expiration for cookie
        const now = new Date()
        now.setTime(now.getTime() + 10 * 60 * 1000)
        // Check 2FA for the account that was already set up before -> direct to SA81(enter otp_code)
        const basePath = PATH[`${route.path.split('/')[1]}`]
        document.cookie = `${basePath.header}-one-time=${JSON.stringify(omit({ ...data?.data }, ['cache-control', 'content-type']))}; expires=${now.toUTCString()}; secure; path=/`
        errorLogin.value = false
        redirectPathFor2Fa()
      } else if (!data?.data?.success) {
        // 2022/09/14 TienNV bug IT ph2 #290
        errorLogin.value = true
        resetCaptCha()
      }
    } catch (error) {
      errorLogin.value = true
      resetCaptCha()
    }
  }
}
const redirectPathFor2Fa = () => {
  router.push({
    path: `/${route.path.split('/')[1]}/input_authentication_code?${route.params?.key}`,
    query: {
      invited_code: route.params?.key,
      redirect: `/alumni/register_alumnus_community?invited_code=${route.params?.key}`,
    },
  })
}

const redirectPage = () => {
  router.push({
    path: `/${route.path.split('/')[1]}/2fa_notification?${route.params?.key}`,
    query: {
      invited_code: route.params?.key,
      redirect: `/alumni/register_alumnus_community?invited_code=${route.params?.key}`,
    },
  })
}

const resetCaptCha = () => {
  // 2022/09/14 TienNV bug UAT ph2 #4435
  checkCaptcha.value = isCheckRecaptcha === 'false'
  formData.value['g-recaptcha-response-data'] = ''
  reCaptChaRef.value.reset()
}

const transitRegister = () => {
  router.push({ path: '/alumni/register_alumnus', query: { invited_code: route.params?.key } })
}

onMounted(async () => {
  const path = PATH[`${route.path.split('/')[1]}`]
  if (route.params?.key) {
    try {
      const invitedCommunityRes = await userService.getInvitedCommunityApi(route.params?.key)

      if (invitedCommunityRes?.response?.status === 400) {
        if (invitedCommunityRes?.response?.data?.data[0]?.message_code === 'INVALID_URL_ERROR') invalidUrlError.value = true
        else {
          invitedCodeNotFound.value = true
        }
      }

      invitedCommunity.value = invitedCommunityRes?.data?.data
      removeCookie(`${path.header}-one-time`)
    } catch (error) {
      console.log(error)
    }
  }
  if (getCookie(path.header) && getCookie(path.pathName)) {
    if (path.header === 'alumni-headers' && path.pathName === 'alumni-path') {
      removeCookie(path.header)
      removeCookie(path?.pathName)
      store.dispatch(AUTH_STORE.ACTIONS.SET_AUTH_VALUE, false)
      store.dispatch(COMMUNITY_STORE.ACTIONS.LOG_OUT)
    } else {
      router.push('/alumni/register_alumnus_community')
      return
    }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (invitedCodeNotFound.value)
      ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
          key: 0,
          title: _unref(translate)('invitedCodeNotFound')
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    (invalidUrlError.value)
      ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
          key: 1,
          title: _unref(translate)('INVALID_URL_ERROR')
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    (!invalidUrlError.value && !invitedCodeNotFound.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", _hoisted_5, [
                _createTextVNode(_toDisplayString(invitedCommunity.value?.corporation_name) + " ", 1),
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(invitedCommunity.value?.community_name) + " ", 1),
                _hoisted_7,
                _hoisted_8
              ]),
              _createElementVNode("h2", _hoisted_9, _toDisplayString(_unref(translate)('notRegistered2')), 1),
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createVNode(Button, {
                  title: _unref(translate)('titleButtonRegis', '', []),
                  onClick: transitRegister
                }, null, 8, ["title"])
              ]),
              _createElementVNode("h2", _hoisted_12, _toDisplayString(_unref(translate)('haveAccount', '', [])), 1),
              _hoisted_13
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                (errorLogin.value)
                  ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
                      key: 0,
                      title: _unref(translate)('systemErr')
                    }, null, 8, ["title"]))
                  : _createCommentVNode("", true),
                _createElementVNode("form", {
                  onSubmit: _withModifiers(submit, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("label", _hoisted_19, _toDisplayString(_unref(translate)('email', '', [])), 1),
                    _createElementVNode("div", _hoisted_20, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "email",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).email.$model) = $event)),
                        class: _normalizeClass(['form-control', _unref(v$).email.$error ? 'is-invalid' : ''])
                      }, null, 2), [
                        [
                          _vModelText,
                          _unref(v$).email.$model,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      _createVNode(InputErrorMessage, {
                        title: 'email',
                        params: [_unref(MIN_LENGTH_EMAIL), _unref(MAX_LENGTH_EMAIL)],
                        validator: _unref(v$).email.$errors[0]?.$validator
                      }, null, 8, ["params", "validator"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("label", _hoisted_22, _toDisplayString(_unref(translate)('password', '', [])), 1),
                    _createElementVNode("div", _hoisted_23, [
                      _withDirectives(_createElementVNode("input", {
                        type: "password",
                        name: "password",
                        class: _normalizeClass(['form-control', _unref(v$).password.$error ? 'is-invalid' : '']),
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).password.$model) = $event))
                      }, null, 2), [
                        [
                          _vModelText,
                          _unref(v$).password.$model,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      _createVNode(InputErrorMessage, {
                        title: 'password',
                        params: [8, 128],
                        validator: _unref(v$).password.$errors[0]?.$validator
                      }, null, 8, ["validator"])
                    ])
                  ]),
                  (isCheckRecaptcha !== 'false')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createVNode(RecaptCha, {
                          ref: (_value, _refs) => {
                            _refs['reCaptChaRef'] = _value
                            reCaptChaRef.value = _value
                          },
                          onVerify: recaptchaVerified
                        }, null, 512)
                      ]))
                    : _createCommentVNode("", true),
                  (checkSubmit.value && !checkCaptcha.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_unref(translate)('SA80errorGGreCaptcha')), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(Button, {
                      title: _unref(translate)('titleButtonLogin'),
                      type: 'secondary',
                      htmlType: 'submit',
                      disabled: disableBtn.value
                    }, null, 8, ["title", "disabled"])
                  ])
                ], 40, _hoisted_17),
                _createElementVNode("label", _hoisted_27, [
                  _createTextVNode(_toDisplayString(_unref(translate)('SA80snsIntegrationNote1')), 1),
                  _hoisted_28,
                  _createTextVNode(_toDisplayString(_unref(translate)('SA80snsIntegrationNote2')), 1)
                ]),
                _createVNode(SnsLoginButton, {
                  class: "social-button-group align-items-center mx-0",
                  "google-theme": "light",
                  arrangement: "vertical",
                  "sns-method": _unref(SNS_METHOD).INVITE
                }, null, 8, ["sns-method"]),
                _createVNode(CardFooter)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})